<template>
  <v-container fluid style="background-color: #fafafa">
    <v-layout d-flex wrap v-bind="binding">
      <v-flex sm12 md12 class="pa-0 px-1">
        <v-card class="mb-3" :loading="fetching" :disabled="fetching">
          <template v-if="getStateTest">
            <v-card-text :class="{ 'black--text': userData.actividad }">
              <div class="d-flex">
                <div class="headline mb-2 black--text">
                  Resultado de Test UNI
                </div>
                <v-spacer></v-spacer>
                <v-btn
                  icon
                  color="success"
                  class="mx-2"
                  @click="fetchStateTest"
                >
                  <v-icon>mdi-reload</v-icon>
                </v-btn>
              </div>
              <v-divider class="mb-4"></v-divider>
              <template v-for="(item, index) in resultadosTest.alumno">
                <v-subheader class="pl-0">{{ item.nombre }}</v-subheader>
                <v-progress-linear
                  :key="index"
                  :color="coloresStats[item.codigo]"
                  height="20"
                  :value="item.porcentaje * 100"
                  striped
                >
                  <template v-slot:default="{ value }">
                    <strong>{{ value.toFixed(2) }}%</strong>
                  </template>
                </v-progress-linear>
              </template>
            </v-card-text>
          </template>
          <template v-else>
            <v-card-text style="height: 375px">
              <v-overlay absolute :opacity="0.65" :value="true">
                <div class="d-flex flex-column align-center justify-center">
                  <p class="text-h6">
                    Para ver tus resultados realiza el Test de Aptitud
                  </p>
                  <v-btn color="success" :to="{ path: '/usuario/prueba' }"
                    >Ir a test</v-btn
                  >
                </div>
              </v-overlay>
            </v-card-text>
          </template>
        </v-card>
      </v-flex>
      <template v-if="getStateTest">
        <template v-if="!getStateTest.ultimaPregunta">
          <v-flex sm12 md12 class="pa-0 px-1">
            <v-card class="mb-3" :loading="fetching" :disabled="fetching">
              <v-card-text :class="{ 'black--text': userData.actividad }">
                <div class="headline mb-2 black--text">
                  Comparación de Resultado de Test UNI
                </div>
                <v-divider class="mb-4"></v-divider>
                <line-statistic :dataReceived="resultadosTest" />
              </v-card-text>
            </v-card>
          </v-flex>
        </template>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as nd from '../../../plugins/normalDistribution'

export default {
  components: {
    LineStatistic: () => import('@/components/user/statistics/lineStatistic')
  },
  props: ['userData'],
  data: function () {
    return {
      editSlider: false,
      ticksLabels: [
        'No busco',
        'Ocasionalmente',
        'Temporalmente',
        'Activamente'
      ],
      estadisticoGlobal: [],
      resultadosTest: [],
      coloresStats: {
        RE: 'light-blue darken-2',
        LI: 'orange lighten-2',
        TF: 'light-green lighten-1',
        TE: 'deep-purple lighten-3',
        CA: 'red lighten-2',
        ES: 'indigo accent-2',
        CE: 'teal lighten-3',
        IC: 'blue lighten-1'
      }
    }
  },

  methods: {
    reloadData() {
      if (this.getResultadosGlobalesTest) {
        if (
          this.getResultadosGlobalesTest.areas &&
          this.getResultadosGlobalesTest.areas.length
        ) {
          this.estadisticoGlobal = this.getResultadosGlobalesTest.areas.map(
            (i) => {
              i.nd = i.desviacionEstandar
                ? new nd.NormalDistribution(i.mediana, i.desviacionEstandar)
                : new nd.NormalDistribution(i.mediana, Math.random())
              return i
            }
          )
        }
      }

      console.log('this.estadisticoGlobal', this.estadisticoGlobal)

      if (this.getStateTest) {
        if (!this.getStateTest.ultimaPregunta) {
          let area
          this.resultadosTest = {
            alumno: [],
            global: []
          }
          for (const key in this.getStateTest.resultados) {
            if (Object.hasOwnProperty.call(this.getStateTest.resultados, key)) {
              const value = this.getStateTest.resultados[key]
              area = this.estadisticoGlobal.find((i) => i.codigo === key)
              if (area) {
                this.resultadosTest.alumno.push({
                  porcentaje: area.nd ? area.nd.cdf(value) : 1,
                  puntaje: value,
                  codigo: key,
                  nombre: area.nombreArea
                })
                this.resultadosTest.global.push({
                  puntaje: area.mediana,
                  codigo: key,
                  nombre: area.nombreArea
                })
              }
            }
          }
        }
      }

      console.log('this.resultadosTest', this.resultadosTest)
    },

    ...mapActions('user', ['fetchStateTest'])
  },

  computed: {
    binding() {
      const binding = {}
      if (this.$vuetify.breakpoint.smAndDown) binding.column = true
      return binding
    },

    ...mapGetters('user', [
      'getResultadosGlobalesTest',
      'getStateTest',
      'fetching'
    ])
  },

  async mounted() {
    await this.reloadData()
  }
}
</script>

<style>
</style>
